<template>
<div>
  <v-dialog v-model="dialogaddbank" persistent max-width="500">
    <v-card>
      <v-card-title class="primary white--text">Tambah Bank</v-card-title>
      <v-card-text>
        <div class="mt-6">
          <v-select
              label="Bank"
              item-text="name"
              item-value="code"
              v-model="addbank.bankcode"
              :items="banks"
          ></v-select>
        </div>
        <div><v-text-field v-model="addbank.accountno" label="No Rekening" ></v-text-field></div>
        <div><v-text-field v-model="addbank.accountname" label="Nama" ></v-text-field></div>
      </v-card-text>
      <v-divider/>
      <v-card-actions>
        <v-spacer/>
        <v-btn elevation="0" dark @click="setdialogaddbank(false)" color="red">Tutup</v-btn>
        <v-btn elevation="0" @click="simpan" :disabled="addbank.accountname.length===0 || addbank.accountno.length===0" color="primary">Simpan</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
  <v-toolbar elevation="0">
    <v-spacer/>
    <v-btn small elevation="0" class="ml-2" color="accent" dark @click.native="setdialogaddbank(true)">
      <v-icon dark>add</v-icon>Tambah
    </v-btn>
    <v-btn small elevation="0" class="ml-2" color="primary" @click.native="getMemberBanks">
      <v-icon dark>refresh</v-icon>Refresh
    </v-btn>
  </v-toolbar>
  <v-divider></v-divider>
  <v-data-table
      :headers="headers"
      :items="memberbanks"
      class="elevation-0"
      item-key="id">
    <template v-slot:item.aksi="{ item }">
      <v-btn x-small dark fab text @click.native="hapus(item)" class="red ml-2">
        <v-icon small>delete</v-icon>
      </v-btn>
    </template>
  </v-data-table>
</div>
</template>

<script>
import { mapActions, mapState } from 'vuex'

export default {
  name: 'MemberBank',
  components: { },
  data: () => ({
    addbank: {
      bankcode: '',
      accountno: '',
      accountname: ''
    },
    banks: [
      {
        code: 'BCA',
        name: 'BCA - Bank Central Asia'
      },
      {
        code: 'MANDIRI',
        name: 'Mandiri - Bank Bandiri'
      },
      {
        code: 'BRI',
        name: 'BRI - Bank Rakyat Indonesia'
      },
      {
        code: 'BNI',
        name: 'BNI - Bank Negara Indonesia'
      }
    ],
    headers: [
      {
        text: 'Bank',
        value: 'bankcode',
        sortable: false
      },
      {
        text: 'No Rekening',
        value: 'accountno',
        sortable: false
      },
      {
        text: 'Nama Rekening',
        value: 'accountname',
        sortable: false
      },
      {
        text: 'Aksi',
        value: 'aksi',
        sortable: false
      }
    ]
  }),
  mounted () {
    this.getMemberBanks()
  },
  computed: {
    ...mapState('SaldoStore', ['memberbanks', 'loading', 'dialogaddbank'])
  },
  methods: {
    ...mapActions('SaldoStore', ['getMemberBanks', 'deleteMemberbank', 'updateMemberbank', 'addMemberBank', 'setdialogaddbank']),
    simpan () {
      this.addMemberBank(this.addbank)
    },
    hapus (val) {
      this.$confirm('Yakin akan Hapus ' + val.accountno + ' ke ' + val.accountname, { color: 'red', title: 'Konfirmasi', icon: 'fa-question' }).then(res => {
        if (res) {
          this.deleteMemberbank(val.id)
        }
      })
    }
  }
}
</script>

<style scoped>

</style>
